import { createLogger } from 'redux-logger';

import requestsStatuses from 'modules/common/constants/requestsStatuses';

export default createLogger({
  collapsed: true,
  timestamp: false,
  diff: true,
  duration: true,

  colors: {
    title: (action) => {
      const type = action.type;

      if (type.startsWith('APOLLO_')) return '#22a699';
      if (type.endsWith(requestsStatuses.pending)) return '#bc9410';
      if (type.endsWith(requestsStatuses.failure)) return '#f20404';
      if (type.endsWith(requestsStatuses.success)) return '#4caf50';

      return 'inherit';
    },
    prevState: () => '#9e9e9e',
    action: () => '#ff6611',
    nextState: () => '#9e9e9e',
    error: () => '#f20404',
  },
});
